import React from "react";
import { motion } from "framer-motion";
import { MapPin, Car, CheckCircle2, Sparkles } from "lucide-react";

const STEPS = [
  { icon: MapPin, title: "Select Trip", desc: "Enter pickup, drop and travel dates." },
  { icon: Car, title: "Choose Vehicle", desc: "Pick from Hatchback, Sedan, SUV or more." },
  { icon: CheckCircle2, title: "Confirm Booking", desc: "Get instant fare on WhatsApp and confirm." },
  { icon: Sparkles, title: "Enjoy Ride", desc: "Professional driver, clean cab, on-time pickup." },
];

const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-it-works-section" className="relative py-20 lg:py-28 bg-[#F8FAFC]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#19A8E8]">How It Works</div>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] tracking-tight leading-tight">
            Book your ride in <span className="text-[#19A8E8]">4 simple steps</span>.
          </h2>
        </div>

        <div className="mt-12 relative">
          {/* Connector line */}
          <div aria-hidden className="hidden lg:block absolute top-7 left-12 right-12 h-px border-t-2 border-dashed border-[#19A8E8]/30"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.title}
                  data-testid={`step-${i + 1}`}
                  initial={{ opacity: 0, y: 14 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="relative"
                >
                  <div className="relative bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-[0_12px_30px_rgba(15,23,42,0.08)] hover:border-[#19A8E8]/40 transition-all">
                    <div className="h-14 w-14 rounded-2xl bg-[#19A8E8] text-white flex items-center justify-center shadow-[0_8px_20px_rgba(25,168,232,0.30)] mb-5">
                      <Icon className="h-6 w-6" />
                    </div>
                    <div className="absolute top-5 right-5 font-display font-extrabold text-3xl text-[#19A8E8]/15 leading-none">
                      0{i + 1}
                    </div>
                    <h3 className="font-display font-semibold text-lg text-[#0F172A]">{s.title}</h3>
                    <p className="mt-1.5 text-sm text-[#64748B] leading-relaxed">{s.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
